'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (link) {
  var maxLength = arguments.length <= 1 || arguments[1] === undefined ? Infinity : arguments[1];

  if (link.length <= maxLength) {
    return link;
  }

  var ellipsis = '...';
  return '' + link.substr(0, maxLength - ellipsis.length) + ellipsis;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/linkhunter/lib/truncate.js
 ** module id = 112
 ** module chunks = 0
 **/